/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import CtaLink from '../../../ui/CtaLink';
import { types, sizes } from '../../../ui/CtaLink/types';
import * as styles from './index.styles';
import React from 'react';
import { style } from '../../../ui/Icon/index.styles';

const prepareLinks = (item, isSitemapPage, treeLevel) => {
  const phase = get(item, 'phase', '');
  const Children = get(item, 'Children', []);
  const CtaLink = get(item, 'links[0].href', '');
  const CTAText = get(item, 'links[0].text', '');
  if(!CtaLink || !CTAText){
    return null;
  }
  return (
    <li css={[styles.item, isSitemapPage && styles.sitemapPageItem]}>
      <a
        href={CtaLink}
        css={[styles.anchorCss, styles.subItemAnchorCss]}
      >
        {phase && (
          <span css={[styles.phaseTxt, styles.phaseBigTxt]}>{phase} </span>
        )}
        <span css={[styles.anchorLabel, styles.anchorSmallLabel]}>
          {CTAText}
        </span>
      </a>

      {Children.length > 0 && (
        <ul css={[styles.subLevel, styles[`subLevel${treeLevel}`]]}>
          {Children.map(cItem =>
            prepareLinks(cItem, isSitemapPage, treeLevel + 1),
          )}
        </ul>
      )}
    </li>
  );
};

const SitemapBlock = props => {
  const links = get(props, 'links', []);
  const phase = get(props, 'phase', '');
  const Children = get(props, 'Children', []);

  // Returns linkItems except the first one because the first one is the headline link.
  const linkItems = Children.map((item, index) =>
    prepareLinks(item, props.isSitemapPage, 0),
  );

  const headlineLinkFields = links[0] || false;

  return (
    <section>
      {phase && (
        <a href={headlineLinkFields.href || '#'} css={styles.anchorCss}>
          <span css={[styles.phaseTxt, styles.phaseSmallTxt]}>{phase}</span>
        </a>
      )}
      <h2
        css={[
          styles.headline,
          props.isSitemapPage && styles.sitemapPageHeadlineCss,
        ]}
      >
        {headlineLinkFields.href ? (
          <React.Fragment>
            <CtaLink
              css={styles.ctalinktxt}
              linkCustomCss={styles.link}
              type={types.tertiary}
              size={sizes.large}
              href={headlineLinkFields.href || '#'}
              text={headlineLinkFields.text || ''}
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
           
            <Text field={{ value: headlineLinkFields.text }} />
          </React.Fragment>
        )}
      </h2>
      {linkItems.length > 0 && (
        <ul css={[styles.items, props.isSitemapPage && styles.sitemapPageCss]}>
          {linkItems}
        </ul>
      )}
    </section>
  );
};

SitemapBlock.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object),
};

export default SitemapBlock;
